export default {
    pleaseCompleteSecurityVerification: "Please complete the security verification",
    slideToTheRightToValidation: "Slide to the right to complete validation",
    verificationSuccessful: "Verification Successful",
    verificationFailed: "Validation Failed"
}